export default "__VITE_ASSET__CV4IYmje__"